import { createAction, props } from '@ngrx/store';
import { DataSource } from '@sharedModule/models/data-source.model';
import { VelocityLimitListInterface } from '../types/velocity-limit-list';
import { VelocityLimitListFilter } from '../types/velocity-limit-list-filter';

export const fetchVelocityLimitList = createAction(
  '[Velocity Limit List] Velocity Limit List Fetch',
  props<{ filter?: VelocityLimitListFilter }>()
);

export const updateVelocityLimitListFilter = createAction(
  '[Velocity Limit Filter] Velocity Limit List update filter',
  props<{ filter?: VelocityLimitListFilter }>()
);

export const loadedVelocityLimitList = createAction(
  '[Velocity Limit List] Velocity Limit List Loaded',
  props<{ dataSource: DataSource<VelocityLimitListInterface[]> }>()
);

export const failedVelocityLimitList = createAction(
  '[Velocity Limit List] Velocity Limit List Failed'
);

export const deleteVelocityLimit = createAction(
  '[Velocity Limit List] Delete Velocity Limit',
  props<{ id: number }>()
);

export const resetVelocityLimitList = createAction(
  '[Velocity Limit List] Reset Velocity Limit List'
);
